// extracted by mini-css-extract-plugin
module.exports = {"cards":"ExpertiseList_cards__Soosu","expertiseCard":"ExpertiseList_expertiseCard___mH0q"};